import { GET_USER_BY_INVITE_TOKEN } from 'actions/Types';

export default function invitedUser(state = null, action) {
  if (action.type === `${GET_USER_BY_INVITE_TOKEN}_SUCCESS`) {
    return action.payload;
  }

  return state;
}
